import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './shared/components/header.component';
import { FooterComponent } from './shared/components/footer.component';
import { ToastComponent } from './shared/components/toast.component';
import { CookieConsentComponent } from './shared/components/cookie-consent.component';
import { CookieConsentService } from './core/services/cookie-consent.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HttpClientModule,
    HeaderComponent,
    FooterComponent,
    ToastComponent,
    CookieConsentComponent
  ],
  template: `
    <app-header></app-header>
    <main class="min-h-screen">
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
    <app-toast></app-toast>
    <app-cookie-consent></app-cookie-consent>
  `,
  styles: []
})
export class AppComponent {
  title = 'Videowand Leipzig';

  constructor(
    private router: Router,
    private cookieConsentService: CookieConsentService
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.cookieConsentService.hasAnalyticsConsent()) {
          this.cookieConsentService.trackPageView(this.router.url);
        }
      });
  }
}
